class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    if (this.hasLoaded) return;
    this.hasLoaded = true;

    const ids = this.getRecentlyViewedIds();
    if (!ids.length) return;

    const section = this.closest(".shopify-section");
    const sectionId = section?.id?.replace("shopify-section-", "");
    if (!sectionId) return;

    const query = ids.map(id => `id:${id}`).join(" OR ");
    const url = `${Shopify.routes.root}search?type=product&q=${encodeURIComponent(query)}&section_id=${sectionId}`;

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('recently-viewed-products');
        if (inner && inner.children.length) {
          this.innerHTML = inner.innerHTML;
        }
      })
      .catch(console.error);
  }

  getRecentlyViewedIds() {
    const raw = localStorage.getItem('theme:recently-viewed-products');
    let ids = raw ? JSON.parse(raw) : [];
    const exclude = parseInt(this.getAttribute('exclude-id'));
    const count = parseInt(this.getAttribute('products-count')) || 8;

    if (!isNaN(exclude)) {
      ids = ids.filter(id => id !== exclude);
    }

    return ids.slice(0, count);
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
